module.exports = __webpack_public_path__ + "img/4club-12.b6f03868.svg";